import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

const searchSchema = z.object({
  source_id: z.string().optional(),
})

export const Route = createFileRoute('/_protected/bridge-builder')({
  beforeLoad: ({ search }) => {
    // Preserve any search parameters during the redirect
    const searchParams = new URLSearchParams()
    if (search.source_id) {
      searchParams.set('source_id', search.source_id)
    }
    
    const redirectPath = `/connection-builder${searchParams.toString() ? `?${searchParams.toString()}` : ''}`
    throw redirect({ to: redirectPath })
  },
  validateSearch: searchSchema,
})